import type { MonetizationOffer } from './types.ts';

export const COASTER_PASS_PRICE_CREDITS = 299;
export const PASSENGER_CAM_PRICE_CREDITS = 25;
export const STANDARD_PERK_PRICE_CREDITS = 5;

export const MONETIZATION_CATALOG = Object.freeze([
  {
    id: 'extra_photo_moments',
    title: 'Extra Photo Moments',
    description: 'Choose from more safe action moments from this ride.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'fresh_highlight_mix',
    title: 'Fresh Highlight Mix',
    description: 'Create another deterministic edit from unused ride moments.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'alternate_camera_style',
    title: 'Alternate Camera Style',
    description: 'Use another preflighted camera style for the selected video.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'photo_frame_filter',
    title: 'Photo Frame & Filter',
    description: 'Add the Park Glow treatment to photos and videos.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'caption_treatment',
    title: 'Caption Treatment',
    description: 'Add a preset ride caption without uploading your media.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'styled_short_loop',
    title: 'Styled Short Loop',
    description: 'Give the existing free loop an optional animated treatment.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'animated_cheer',
    title: 'Animated Cheer',
    description: 'Play a local celebration with no effect on popularity or ranking.',
    priceCredits: STANDARD_PERK_PRICE_CREDITS,
    rewardedAdAvailable: true,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'passenger_cam',
    title: 'Passenger Cam',
    description: 'Place your current Reaction Cam recording into the coaster car.',
    priceCredits: PASSENGER_CAM_PRICE_CREDITS,
    rewardedAdAvailable: false,
    includedInCoasterPass: true,
    durable: false,
  },
  {
    id: 'coaster_pass',
    title: 'Coaster Pass',
    description: 'Unlock every Phase 8 media treatment in the QA sandbox.',
    priceCredits: COASTER_PASS_PRICE_CREDITS,
    rewardedAdAvailable: false,
    includedInCoasterPass: false,
    durable: true,
  },
] as const satisfies readonly MonetizationOffer[]);
